<script>

import TrainingPlayer from "@/components/trainings/TrainingPlayer.vue";
import {headerState} from "@/stores/headerStore.js";
import TrainingSelectedDates from "@/components/trainings/thumbnail/TrainingSelectedDates.vue";
import CertificateDownloadButton from "@/components/trainings/CertificateDownloadButton.vue";

export default {
    components: {CertificateDownloadButton, TrainingSelectedDates, TrainingPlayer},
    data() {
        return {
            training: null,
            loading: true,
        }
    },
    methods: {},
    mounted() {
        axios.get('/trainings/' + this.$route.params.id).then((response) => {
            this.training = response.data.data;
            headerState.title = this.training.name;
        }).catch(() => {
        }).finally(() => {
            this.loading = false;
        })
    },
    beforeUnmount() {
    }
}

</script>
<template>
    <div class="trainings-show">

        <loader :loading="loading"></loader>
        <div v-if="!loading">
            <div class="mb-4 certificate-btn">
                <CertificateDownloadButton v-if="$auth.isEmployee()" :training="training"/>
            </div>
            <div class="mb-4 training-dates">
                <TrainingSelectedDates :training="training"/>
            </div>
            <div class="mb-4 training-description">
                {{ training.description }}
            </div>
            <TrainingPlayer v-if="training.audio_url"
                            :audio-url="training.audio_url"
                            :slides="training.images"/>
        </div>
    </div>
</template>

<style scoped>
    .training-description {
        white-space: pre-line;
    }
    .training-dates {
        display: flex;
        gap: 1rem;
    }
</style>
